window.silesia = window.silesia || {};
window.silesia.layout = window.silesia.layout || {};


window.silesia.layout.headerSearch = function(visibility=false) {
    return {
        visibility:visibility,

        init() {
            alert(this.visibility, this.toggle);
        },

        toggle() {
            var self = this;

            self.visibility = !self.visibility;
            
        }
    }
};



if(document.querySelector('*[x-data-lazy*="window.silesia.layout.headerSearch"]')) {
    Array.from(document.querySelectorAll('*[x-data-lazy*="window.silesia.layout.headerSearch"]')).forEach((el) => {
        el.setAttribute('x-data', el.getAttribute('x-data-lazy'))
        el.removeAttribute('x-data-lazy');
    });
}
